//公共的
const COMMON_JP = {
  NOW_ADDRESS_TEXT_1: '同じ',
  NOW_ADDRESS_TEXT_2: '異なる',
  MES_TEXT_1: '特殊文字は入力できません。',
  MES_TEXT_2: '半角数字/半角英字を入力してください。',
  MES_TEXT_3: 'エラーが発生しました。くり返し発生する場合はお問い合わせください。',
  TIPS_TEXT_1: '申請が完了しました。お申込み画面へ戻ります。',
  BACK_TIPS_TEXT: 'ご入力内容が反映されません。確認画面に戻りますか？',
  BACK_TIPS_YES_BNT: 'はい',
  BACK_TIPS_NO_BNT: 'いいえ',
  ADDR_FORMAT_ERROR_FF0D: '漢字/ひらがな/全角カタカナ/数字/英字/ー/空白スペースを入力してください。',//全角ハイフン-マイナス U+FF0D
  ADDR_FORMAT_ERROR_30FC:  '漢字/ひらがな/全角カタカナ/数字/英字/ー/空白スペースを入力してください。',//カタカナ-ひらがな延長サウンドマーク U+30FC
  ADDR_FORMAT_ERROR_FF0D_30FC: '建物名・部屋番号等を正しく入力してください（カタカナ、ハイフンは全角で入力）。',//全角ハイフン-マイナス U+FF0D カタカナ-ひらがな延長サウンドマーク U+30FC
  ADDRESS2_MSG: '全角カナ/数字/ー にて入力してください',
}
//组件内的
const COMPONENTS_JP = {}

//邀请界面 /setEmail
const SET_EMAIL_JP = {
  MESSAGE: 'メールアドレスを正しく入力してください。',
  INPUT_TIPS: '入力内容をご確認ください'
}
//姓名界面 /nameBirthdaySex
const NAME_BIRTHDAY_SEX_JP = {
  BIRTH_MSG: '生年月日を正しく入力してください。',
  NAME_TITLE_1: 'お名前（全角）',
  NAME_TITLE_2: 'フリガナ（全角カタカナ）',
  NAME_PLACEHOLDER_1: '姓',
  NAME_MESSAGE_1: '姓を正しく入力してください。',
  NAME_PLACEHOLDER_2: '名',
  NAME_MESSAGE_2: '名を正しく入力してください。',
  NAME_KOKA_PLACEHOLDER_1: 'セイ',
  NAME_KOKA_MESSAGE_1: '姓をカタカナで入力してください。',
  NAME_KOKA_PLACEHOLDER_2: 'メイ',
  NAME_KOKA_MESSAGE_2: '名をカタカナで入力してください。',
  BIRTH_MSG_2: '未成年の方はお申込みいただけません。',
  BIRTH_MSG_3: '75歳以上の方はお申込みできません。',
}

//国籍  /nationalty
const NATIONALTY_JP = {
  MESSAGE: '漢字/ひらがな/全角カタカナ/半角英字/空白スペースを入力してください。'
}
// 住所  /address
const ADDRESS_JP = {
  PLACEHOLDER: '中央区　中央町',
  ADDRESS2_MESSAGE: '漢字/ひらがな/全角カタカナ/数字/英字/ー/-/空白スペースを入力してください。'
}
// 电话  /tel
const TEL_JP = {
  MESSAGE: '携帯電話番号を正しく入力してください。',
  MESSAGE1: '電話番号を正しく入力してください。'
}

//金融机构 /financialbank
const FINANCIAL_BANK_JP = {
  ACCOUNT_TYPE_NAME: '普通預金',
  ERR_MSG: '金融機関を入力してください。',
}

//内部者  /insiderFlg
const INSIDERFLG_JP = {
  INSIDERTYPE_TEXT_1: '該当する',
  INSIDERTYPE_TEXT_2: '該当しない',
  SELECTARR_TEXT_1: '上場会社等',
  SELECTARR_TEXT_2: '上場投資法人等',
  SELECTARR_TEXT_3: 'その他',
  ERROR_MSG: '漢字/ひらがな/全角カタカナ/全角英字/半角英字で入力してください',
  TIPS_MSG: '会社の種類を選択してください',
}
//登陆密码 /loginPassword
const LOGIN_PASSWORD_JP = {
  FORMDATA_TITLE_1: 'パスワード',
  FORMDATA_TITLE_2: 'パスワード（確認）',
  FORMDATA_MSG_1: '正しいパスワードを入力してください。',
  FORMDATA_MSG_2: '入力されたパスワードとパスワード（確認）が一致しません。',
  ERROR_MSG_1: 'パスワードの形式が正しくありません。',
  ERROR_MSG_2: 'パスワードを入力してください。',
  TIPS_TEXT: 'ログインパスワードの桁数は8桁以上16桁以下とし、半角英字、半角数字、半角記号をすべて組み合わせて設定してください。記号は!#%\'()/*+<=>?@[]^_{}~が使用できます。'
}
//是否发送邮件 /isEmailSend
const EMAIL_SEND_JP = {
  TYPE_TEXT_1: '希望する',
  TYPE_TEXT_2: '希望しない',
}

//个人确认界面 /confirmInfo
const CONFIRMINFO_JP = {
  NAMEINFO_TITLE_1: 'お名前',
  NAMEINFO_TITLE_2: '生年月日',
  NAMEINFO_TITLE_3: '性別',

  NATIONALITYINFO_TITLE_1: '国籍',
  NATIONALITYINFO_TITLE_2: '住所',
  NATIONALITYINFO_TITLE_3: '年1月1日時点の住所',
  NATIONALITYINFO_TITLE_4: 'ご連絡先',
  NATIONALITYINFO_TITLE_5: '出金先の金融機関',
  NATIONALITYINFO_TITLE_6: '職業',

  OCCUPTIONINFO_TITLE_1: '勤務先名',
  OCCUPTIONINFO_TITLE_2: '所属部署',
  OCCUPTIONINFO_TITLE_3: '役職名',
  OCCUPTIONINFO_TITLE_4: '業種',

  INSIDERARR_TITLE: '内部者登録',
  FUND_INSIDERARR_TITLE: '当社取扱ファンド内部者登録',

  INVESTINFO_TITLE_1: 'お申込みの動機',
  INVESTINFO_TITLE_2: '投資の目的',
  INVESTINFO_TITLE_3: '年収',
  INVESTINFO_TITLE_4: '主な収入の種類',
  INVESTINFO_TITLE_5: '金融資産の状況',
  INVESTINFO_TITLE_6: '投資資金の内容',
  INVESTINFO_TITLE_7: '現物株式取引の投資経験',
  INVESTINFO_TITLE_8: 'デリバティブ取引の投資経験',
  INVESTINFO_TITLE_9: '投資信託・債券・貴金属取引の投資経験',
  INVESTINFO_TITLE_10: '興味のある投資商品',
  INVESTINFO_TITLE_11: 'ログインパスワード',
  INVESTINFO_TEXT: '●●●●●●●●',
  INVESTINFO_TITLE_12: 'メール配信',

  MOBILE_TEXT_1: '固定電話番号：',
  MOBILE_TEXT_2: '携帯電話番号：',
  MOBILE_TEXT_3: 'メールアドレス：',

  TEXT_1: '口座番号：',

  INSIDERTYPE_TEXT_1: '銘柄コード：',
  INSIDERTYPE_TEXT_2: '内部関係者区分：',
  INSIDERTYPE_TEXT_3: '内部者氏名：',
  INSIDERTYPE_TEXT_4: 'の内部者に該当',
  INSIDERTYPE_TEXT_5: '会社名：',


  TITLE_TEXT_1:'キャンペーンコード',

  SEND_TEXT_1:'希望する',
  SEND_TEXT_2:'希望しない',
}
//电子邮件地址(稍后提出)   /documentVerifySetEmail
const DOCUMENT_VERIFY_SET_EMAIL_JP = {
  TITLENAME: 'メールアドレスを入力してください',
  ERROR_MSG: 'メールアドレスを正しく入力してください。',
}
//法人姓名 /corporateNameNumber
const CORPORATE_NAME = {
  msgName: '法人名を全角で入力してください。',
  msgKana: '法人名を全角カタカナで入力してください。',
  msgNum: '法人番号を正しく入力してください。',
}

//电话号码提示语 /representativeTel
const CORPORATE_Tel = '電話番号を正しく入力してください。'


const RESET_CONFIRM_INFO_JP = {
  ERROR_MSG: '参数丢失'
}

//[个人]再提出 姓名界面
const RESET_NAME_BIRTHDAY_SEX_JP = {
  BIRTH_MSG: '生年月日を正しく入力してください。',
  NAME_TITLE_1: 'お名前（全角）',
  NAME_TITLE_2: 'お名前（全角カタカナ）',
  NAME_PLACEHOLDER_1: '姓',
  NAME_MESSAGE_1: '姓を全角で入力してください',
  NAME_PLACEHOLDER_2: '名',
  NAME_MESSAGE_2: '名を全角で入力してください',
  NAME_KOKA_PLACEHOLDER_1: 'セイ',
  NAME_KOKA_MESSAGE_1: '姓を全角カタカナで入力してください',
  NAME_KOKA_PLACEHOLDER_2: 'メイ',
  NAME_KOKA_MESSAGE_2: '名を全角カタカナで入力してください',
  BIRTH_MSG_2: '未成年の方はお申込みいただけません。'
}

// [个人]再提出住所  /address
const RESET_ADDRESS_JP = {
  PLACEHOLDER: '中央区　中央町',
  ADDRESS2_MESSAGE: '漢字/ひらがな/全角カタカナ/数字/英字/ー/-/空白スペースを入力してください。'
}

//投资商品（个人法人）
const DESIRED_INVESTMENT_TYPE_JP={
  PLACEHOLDER_ARR: [
    '地域を入力してください。',
    'その他の内容を入力してください。'
  ]
}
//transactionManager
const TRANSACTION_MANAGER_JP={
  TEL_MSG:[
    '取引責任者の電話番号を正しく入力してください。',
    '電話番号を正しく入力してください。',
  ]
}
const CORPORATE_WITHDRAW_ACCOUNT_JP={
  ERROR_MSG:'全角カタカナ、￥．「」（ ）ー /　で入力してください'
}
export {
  COMMON_JP,
  COMPONENTS_JP,
  SET_EMAIL_JP,
  NAME_BIRTHDAY_SEX_JP,
  NATIONALTY_JP,
  ADDRESS_JP,
  TEL_JP,
  FINANCIAL_BANK_JP,
  INSIDERFLG_JP,
  LOGIN_PASSWORD_JP,
  EMAIL_SEND_JP,
  CONFIRMINFO_JP,
  DOCUMENT_VERIFY_SET_EMAIL_JP,
  CORPORATE_NAME,
  CORPORATE_Tel,
  RESET_CONFIRM_INFO_JP,
  RESET_NAME_BIRTHDAY_SEX_JP,
  RESET_ADDRESS_JP,
  DESIRED_INVESTMENT_TYPE_JP,
  TRANSACTION_MANAGER_JP,
  CORPORATE_WITHDRAW_ACCOUNT_JP
}



// WEBPACK FOOTER //
// ./src/utils/custom_language_jp.js